import React from 'react';

/**
 * Per-tab error boundary — isolates a crash in one TestBed tab so the
 * whole page doesn't fall to the top-level ErrorBoundary. Also surfaces
 * the actual error inline so the developer/tester can screenshot it.
 */
class TabErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(`[TabErrorBoundary:${this.props.tabName}]`, error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8 }}>
          <h3 style={{ color: '#991b1b', marginTop: 0 }}>Tab "{this.props.tabName}" crashed</h3>
          <p style={{ color: '#7f1d1d' }}>The rest of TestBed is unaffected — switch tabs to continue.</p>
          <details style={{ marginTop: 12 }}>
            <summary style={{ cursor: 'pointer', color: '#7f1d1d', fontWeight: 600 }}>Error details</summary>
            <pre style={{ fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#fff', padding: 10, borderRadius: 4, marginTop: 8 }}>
              {this.state.error?.toString()}
              {'\n\n'}
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
          <button
            style={{ background: '#dc2626', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 4, cursor: 'pointer', marginTop: 12 }}
            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default TabErrorBoundary;
